import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { Actions, BorderGradient, Belt, Helper } from 'Components';
import './SuppliesDesktopSearchHeader.css';

const SuppliesSearchHeader = ({
  onPageSizeChange,
  showNoInformationFound,
  onSearchDownload,
}) => (
  <div className="supplies-desktop-search-header">
    <div className="supplies-desktop-search-header__controls">
      <Belt>
        <Helper text={i18n.t('tutorials:common.ExportToExcel')}>
          <Actions.ExportToExcel
            onClick={onSearchDownload}
          />
        </Helper>
        <Helper text={i18n.t('tutorials:search.4')} placement="bottom-left">
          <Actions.ClearSearch to="/supplies" />
        </Helper>
      </Belt>
    </div>
    <BorderGradient />
    {
      showNoInformationFound &&
      <div className="supplies-desktop-search-header__results-per-page">
        <Actions.ResultsPerPage onChange={onPageSizeChange} />
      </div>
    }
  </div>
);

SuppliesSearchHeader.propTypes = {
  onPageSizeChange: PropTypes.func,
  showNoInformationFound: PropTypes.bool,
  onSearchDownload: PropTypes.func,
};

export default SuppliesSearchHeader;



// WEBPACK FOOTER //
// ./src/containers/Supplies/SuppliesDesktop/SuppliesDesktopSearchHeader/SuppliesDesktopSearchHeader.jsx